// ABOUTME: Explains the operational steps for configuring WhatsApp pre-registration.
// ABOUTME: Keeps the guidance available without changing configuration or rollout state.
import React from "react";
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography
} from "@material-ui/core";

import { WhatsappPreRegistrationLabels } from "./whatsappPreRegistrationLabels";

interface WhatsappPreRegistrationHelpDialogProps {
    open: boolean;
    labels: WhatsappPreRegistrationLabels;
    onClose: () => void;
}

const WhatsappPreRegistrationHelpDialog = ({
    open,
    labels,
    onClose
}: WhatsappPreRegistrationHelpDialogProps) => {
    const helpItems = [
        labels.helpIntegration,
        labels.helpDestinations,
        labels.helpRouting,
        labels.helpOwners,
        labels.helpActivation,
        labels.helpGeneralNumber,
        labels.helpLinks,
        labels.helpServerValidation
    ];

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
            aria-labelledby="whatsapp-pre-registration-help-title"
            aria-describedby="whatsapp-pre-registration-help-description"
        >
            <DialogTitle id="whatsapp-pre-registration-help-title">
                {labels.helpTitle}
            </DialogTitle>
            <DialogContent dividers>
                <Typography
                    id="whatsapp-pre-registration-help-description"
                    variant="body2"
                    paragraph
                >
                    {labels.helpIntro}
                </Typography>
                {helpItems.map((item) => (
                    <Box key={item} mb={2}>
                        <Typography variant="body2">{item}</Typography>
                    </Box>
                ))}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="primary">
                    {labels.close}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default WhatsappPreRegistrationHelpDialog;
